import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../util/guideline'
import { Isin } from '../models'
import { UpdateIsin } from './UpdateIsin'

interface UpdateIsinDrawerProps {
  isin: Isin
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateIsinDrawer = ({ isin, isVisible, onClose, onSuccess }: UpdateIsinDrawerProps) => (
  <Drawer
    title="Update ISIN"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <UpdateIsin isin={isin} onSuccess={onSuccess} />
  </Drawer>
)
